import { render, staticRenderFns } from "./VeloAboAwaiting.vue?vue&type=template&id=9637e5b0&"
import script from "./VeloAboAwaiting.vue?vue&type=script&lang=js&"
export * from "./VeloAboAwaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports